import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CheckmarkIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M9.915 20.1725L2 12.8812L4.75437 9.89062L9.49875 14.26L18.8531 2.8275L22 5.4025L9.915 20.1725Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CheckmarkIcon.displayName = 'CheckmarkIcon';
